import { ETripAssignment, TransportSubTypes, TransportType } from 'types/transport';

export const TRANSPORT_TYPE_OPTIONS = Object.values(TransportType).map((type) => ({
  value: type,
  label: type,
}));

export const TRANSPORT_SUBTYPE_OPTIONS = Object.entries(TransportSubTypes).map(([value, label]) => ({
  value,
  label,
}));

export const TRIP_ASSIGNMENT_OPTIONS = [
  { value: ETripAssignment.all, labelKey: 'transport:trip_assignment_all' },
  { value: ETripAssignment.with_trip, labelKey: 'transport:trip_assignment_with_trip' },
  { value: ETripAssignment.without_trip, labelKey: 'transport:trip_assignment_without_trip' },
] as const;
